<template>
  <div class="instructions-text">
  <FontAwesomeIcon icon="fa-solid fa-circle-info" />
  {{ transQuestion }}
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps({
  question: Object,
  current_lang: String,
  index: Number,
})

const transQuestion = computed(() => {
  const reducedArray = {}
  props.question.question.translations.forEach((item) => {
    reducedArray[item.locale] = item.text
  })
  return reducedArray[props.current_lang]
    ?? reducedArray['en']
    ?? reducedArray['fi']
    ?? reducedArray['sv']
    ?? {}
})
</script>

<style scoped>
svg {
    padding: 0 12px;
}
</style>
